// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tEVFU{min-width:100%}.XOxQZ{display:flex;align-items:left;margin-left:15px}`, "",{"version":3,"sources":["webpack://./src/components/PerformanceSummary/components/PerformanceTable/Table.module.scss"],"names":[],"mappings":"AAAA,OACI,cAAA,CAGJ,OACI,YAAA,CACA,gBAAA,CACA,gBAAA","sourcesContent":[".table {\n    min-width: 100%;\n}\n\n.leftAligned {\n    display: flex;\n    align-items: left;\n    margin-left: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `tEVFU`,
	"leftAligned": `XOxQZ`
};
export default ___CSS_LOADER_EXPORT___;
